import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton } from '../../../components/common';
import { MainSource } from '../../../constants/Source';
import { SystemFolderId } from '../../../constants/SystemFolderId';
import { Truncated } from './components';
import { GenericNotification } from './GenericNotification';

export const purchaseSucceedNotification = ({ item }) => {
  const NotificationComponent = ({ openFolderById, notification }) => {
    const openPurchasedFolder = useCallback(
      () => openFolderById(SystemFolderId.Purchased, MainSource.SiteFiles, ''),
      [openFolderById],
    );

    return (
      <GenericNotification
        notification={notification}
        text={
          <FormattedMessage
            id="files-manager.purchased-item-notification"
            values={{
              itemName: <Truncated>{item.name}</Truncated>,
              purchasedLink: (
                <TextButton
                  as="a"
                  size="small"
                  onClick={openPurchasedFolder}
                  underline="always"
                  skin="dark"
                  dataHook="notification-link"
                >
                  <FormattedMessage id="system-folder.purchased" />
                </TextButton>
              ),
            }}
          />
        }
      />
    );
  };

  return NotificationComponent;
};
